export default function SavingChanges() {
  return (
    <section id="saving">
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">Saving Changes</h2>

      <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5 space-y-4 text-sm text-slate-600 dark:text-slate-400">
        <p>
          Bedrock Toolchest uses a staged save system. Changes you make across all tabs are collected
          and applied together when you click <strong>Save Changes</strong> in the footer bar.
        </p>

        <ol className="space-y-2 list-decimal list-inside">
          <li>Make changes across any tabs — level settings, player data, world edits, addons, etc.</li>
          <li>The footer bar shows a save button when there are unsaved changes.</li>
          <li>Click <strong>Save Changes</strong> to apply everything at once.</li>
          <li>A backup is automatically created before saving.</li>
        </ol>

        <div>
          <h3 className="font-medium text-slate-800 dark:text-slate-200 mb-2">Destructive operations</h3>
          <p>
            Some operations — like chunk pruning, dimension resets, and End gateway removal — are
            applied immediately rather than staged. These operations show a confirmation dialog and
            create a backup beforehand.
          </p>
        </div>

        <div className="rounded-lg border border-amber-200 dark:border-amber-800/50 bg-amber-50 dark:bg-amber-900/20 p-3">
          <p className="text-amber-700 dark:text-amber-400 text-xs">
            If you close the program without saving, all unsaved changes are lost. The program will
            warn you if you try to close with pending changes.
          </p>
        </div>

        <div className="rounded-lg border border-blue-200 dark:border-blue-800/50 bg-blue-50 dark:bg-blue-900/20 p-3">
          <p className="text-blue-700 dark:text-blue-400 text-xs">
            After saving, remember to close the world in Bedrock Toolchest before opening it in
            Minecraft. Your changes won't appear in-game if both programs have the world open at the
            same time.
          </p>
        </div>
      </div>
    </section>
  );
}
